import React from 'react';
import { trans } from '../utils';

/**
 * Context Banner - Shows current data context the chat is aware of
 */
const ContextBanner = ({ context, onDismiss }) => {
  if (!context || !context.description) return null;

  return (
    <div className="chat-context-banner" role="status" aria-live="polite">
      <div className="chat-context-banner-content">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <span className="chat-context-banner-text">
          {trans("I can see you're viewing")}: {context.description}
        </span>
      </div>
      
      {onDismiss && (
        <button
          className="chat-context-banner-dismiss"
          onClick={onDismiss}
          aria-label={trans('Dismiss context banner')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      )}
    </div>
  );
};

export default ContextBanner;
